import React, { useEffect,useState } from "react";
import styled from "styled-components";
import smoothscroll from "smoothscroll-polyfill";

// Styles
import GlobalStyles from "../styles/globalStyles";
import "../styles/normalize.css";

// Components
import { DefaultSEO } from "./default-seo";

const Container = styled.div`
  position: relative;
`;

const Layout = ({ children }) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);


  useEffect(() => {
    // kick off the polyfill!
    smoothscroll.polyfill();
  }, []);

  if (!hasMounted) {
    return null;
  }

  return (
    <Container>
      <GlobalStyles />
      <DefaultSEO />
      <main>{children}</main>
    </Container>
  );
};

export default Layout;
